module.exports = __webpack_public_path__ + "img/dash-card-edit-icon.2f0c0b8a.svg";